import { render, staticRenderFns } from "./info-tip.vue?vue&type=template&id=e26d85b6&scoped=true&"
import script from "./info-tip.vue?vue&type=script&lang=js&"
export * from "./info-tip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26d85b6",
  null
  
)

export default component.exports